var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"headbar",attrs:{"data-is-transparent-bg":_vm.transparentBg}},[_c('div',{staticClass:"headbar-icon"}),_vm._t("default"),_c('div',{staticClass:"headbar-right"},[_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }